import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { usePaymentTasks } from '@/hooks/api/0960_payment_tasks';
import { Link } from 'react-router-dom';
import { Fragment } from 'react';
import { MotionDiv } from '@/components/element/MotionDiv';

export const PaymentTasks = () => {
  const { _w_, _t_, me, meTeamMember } = useCurrentTeamMember();
  const { _po_, mePurchaseOrderMember } = useCurrentPurchaseOrder();
  const { data: tasks } = usePaymentTasks({
    identifier: _w_!.identifier,
    purchase_order_id: _po_!.id,
    archived: true,
    page: 1,
    per: 1000,
  });

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">支払タスク一覧</h6>
        </div>
        {['contracting', 'completed'].includes(_po_ ? _po_.team_purchase_order_phase.name : '') && (
          <Link
            to={`/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}/payment_tasks/new`}
            className="btn bg-gradient-primary btn-icon flex-shrink-0"
          >
            <i className="fas fa-plus"></i>新規タスク作成
          </Link>
        )}
      </div>
      <div className="card-body pt-0">
        {tasks?.payment_tasks.map((d, i) => (
          <Fragment key={`pt-${d.id}`}>
            {i != 0 && <hr className="horizontal dark" />}
            <Link
              to={`/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}/payment_tasks/${d.id}`}
              className="d-flex align-items-center justify-content-between"
            >
              <div className="d-flex align-items-center">
                <div className="icon icon-sm bg-dark d-flex border-radius-md align-items-center justify-content-center flex-shrink-0">
                  <i className="fas fa-receipt text-white"></i>
                </div>
                <div className="ms-2">
                  <div className="font-weight-bold px-0 text-sm text-dark mb-1">{d.name}</div>
                  <div className="text-muted font-weight-bold text-xs">
                    {d.payment_task_phase.label}, ¥
                    {d.payment_task_phase.name == 'accepted'
                      ? d.payment_schedule_detail.amount.toLocaleString()
                      : d.payment_amount?.toLocaleString()}
                  </div>
                </div>
              </div>
              <i className="fas fa-angle-right text-muted opacity-3 flex-shrink-0 ms-2"></i>
            </Link>
          </Fragment>
        ))}
      </div>
    </MotionDiv>
  );
};
